export class TaskType {
    constructor({
            //attributes
            id=null,
            company_id=null, 
            name='' 
                } = {}) {

        //fill attributes
        this.id=id;
        this.company_id=company_id;
        this.name=name;
    }
}

export function createTaskType(data={}) {
    return Object.freeze(new TaskType(data));
}